// src/pages/PaymentSuccess.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import API_BASE_URL from '../config/api';

const PaymentSuccess = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const transactionId = queryParams.get('transaction_id') || queryParams.get('transactionId');
  const email = queryParams.get('email') || queryParams.get('user_email');
  const event = queryParams.get('event');

  useEffect(() => {
    if (transactionId && email) {
      fetch(`${API_BASE_URL}/api/payment/success`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ transactionId, email, event }),
      });
    }
  }, [transactionId, email, event]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>✅ Thank you for registering!</h1>
      <p>Your Transaction ID: {transactionId || 'Not available'}</p>
      {!transactionId || !email ? (
        <p>Payment was completed, but callback details are incomplete. Please contact organizers with your payment receipt.</p>
      ) : null}
    </div>
  );
};

export default PaymentSuccess;
